import { failed } from "../../components/common/Toastify"

export const onError = (error) => {
    if (error?.isTokenExpired) {
        return;
    }
    failed(error?.response?.data?.message || error?.response?.data?.error || error.message)
}